"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.currentPriceComparisonProps = exports.PlanKey = void 0;
var PlanKey;
(function (PlanKey) {
    PlanKey["FREE"] = "FREE";
    PlanKey["LANDED_COST"] = "LANDED_COST";
    PlanKey["BASIC"] = "BASIC";
    PlanKey["PRO"] = "PRO";
    PlanKey["ORG"] = "ORG";
})(PlanKey = exports.PlanKey || (exports.PlanKey = {}));
exports.currentPriceComparisonProps = {
    mostPopular: PlanKey.PRO,
    plans: [
        // {
        //   key: PlanKey.FREE,
        //   name: 'Free',
        //   price: '$0',
        //   description: '',
        //   callToAction: {
        //     text: 'Create a free account',
        //   },
        // },
        {
            key: PlanKey.BASIC,
            name: "Basic",
            price: "$29/mo",
            description: "Billed annually\nor $39 month-to-month",
            callToAction: {
                text: "Start a free trial",
            },
        },
        {
            key: PlanKey.PRO,
            name: "Professional",
            price: "$75/mo",
            description: "Billed annually\nor $99 month-to-month",
            callToAction: {
                text: "Start a free trial",
            },
        },
        {
            key: PlanKey.ORG,
            name: "Organization",
            price: "$199/mo",
            description: "Billed annually only",
            callToAction: {
                text: "Start a free trial",
            },
        },
    ],
    featureGroups: [
        {
            name: "Usage",
            features: [
                {
                    name: "Members",
                    tooltip: "Members are teammates you can invite to your workspace to access information and create documents alongside you in the cloud.",
                    usageCaps: [
                        {
                            plan: PlanKey.FREE,
                            available: "Just you",
                        },
                        {
                            plan: PlanKey.BASIC,
                            available: "Just you",
                        },
                        {
                            plan: PlanKey.PRO,
                            available: "2 members",
                        },
                        {
                            plan: PlanKey.ORG,
                            available: "10 members",
                        },
                    ],
                },
                {
                    name: "Export Document Sets",
                    tooltip: "Sets are smart folders which are used to store all the export documents related to a particular shipment.",
                    usageCaps: [
                        {
                            plan: PlanKey.FREE,
                            available: "First 3",
                        },
                        {
                            plan: PlanKey.BASIC,
                            available: "10 per month",
                        },
                        {
                            plan: PlanKey.PRO,
                            available: "Unlimited",
                        },
                        {
                            plan: PlanKey.ORG,
                            available: "Unlimited",
                        },
                    ],
                },
                {
                    name: "Invoices",
                    usageCaps: [
                        {
                            plan: PlanKey.FREE,
                            available: "First 5",
                        },
                        {
                            plan: PlanKey.BASIC,
                            available: "20 per month",
                        },
                        {
                            plan: PlanKey.PRO,
                            available: "Unlimited",
                        },
                        {
                            plan: PlanKey.ORG,
                            available: "Unlimited",
                        },
                    ],
                },
                {
                    name: "Purchase Orders",
                    usageCaps: [
                        {
                            plan: PlanKey.FREE,
                            available: "First 5",
                        },
                        {
                            plan: PlanKey.BASIC,
                            available: "20 per month",
                        },
                        {
                            plan: PlanKey.PRO,
                            available: "Unlimited",
                        },
                        {
                            plan: PlanKey.ORG,
                            available: "Unlimited",
                        },
                    ],
                },
                {
                    name: "Quotes",
                    usageCaps: [
                        {
                            plan: PlanKey.FREE,
                            available: "Unlimited",
                        },
                        {
                            plan: PlanKey.BASIC,
                            available: "Unlimited",
                        },
                        {
                            plan: PlanKey.PRO,
                            available: "Unlimited",
                        },
                        {
                            plan: PlanKey.ORG,
                            available: "Unlimited",
                        },
                    ],
                },
            ],
        },
        {
            name: "Core Features",
            showPlanTitles: true,
            features: [
                {
                    name: "Contacts & Products Database",
                    tooltip: "Save & re-use contact & product information to insert on documents at the click of a button.",
                    usageCaps: [
                        {
                            plan: PlanKey.FREE,
                            available: true,
                        },
                        {
                            plan: PlanKey.BASIC,
                            available: true,
                        },
                        {
                            plan: PlanKey.PRO,
                            available: true,
                        },
                        {
                            plan: PlanKey.ORG,
                            available: true,
                        },
                    ],
                },
                {
                    name: "Snippets",
                    tooltip: "Save common fields so you can click to insert lines of text into documents, to eliminate manual entering of information.",
                    usageCaps: [
                        {
                            plan: PlanKey.FREE,
                            available: true,
                        },
                        {
                            plan: PlanKey.BASIC,
                            available: true,
                        },
                        {
                            plan: PlanKey.PRO,
                            available: true,
                        },
                        {
                            plan: PlanKey.ORG,
                            available: true,
                        },
                    ],
                },
                {
                    name: "Digital Signatures",
                    tooltip: "Create a professional digital signature and sign documents in seconds.",
                    usageCaps: [
                        {
                            plan: PlanKey.FREE,
                            available: true,
                        },
                        {
                            plan: PlanKey.BASIC,
                            available: true,
                        },
                        {
                            plan: PlanKey.PRO,
                            available: true,
                        },
                        {
                            plan: PlanKey.ORG,
                            available: true,
                        },
                    ],
                },
                {
                    name: "Digital Stamping",
                    tooltip: "Upload or create your own digital company seal to place on documents at the click of a button. No printing or scanning required!",
                    usageCaps: [
                        {
                            plan: PlanKey.FREE,
                            available: true,
                        },
                        {
                            plan: PlanKey.BASIC,
                            available: true,
                        },
                        {
                            plan: PlanKey.PRO,
                            available: true,
                        },
                        {
                            plan: PlanKey.ORG,
                            available: true,
                        },
                    ],
                },
                {
                    name: "Document Autofill",
                    tooltip: "Autofill data from any previous document at the click of a button to streamline document creation and minimise human error.",
                    usageCaps: [
                        {
                            plan: PlanKey.FREE,
                            available: true,
                        },
                        {
                            plan: PlanKey.BASIC,
                            available: true,
                        },
                        {
                            plan: PlanKey.PRO,
                            available: true,
                        },
                        {
                            plan: PlanKey.ORG,
                            available: true,
                        },
                    ],
                },
                {
                    name: "SmartSync",
                    tooltip: "SmartSync lets you enter your information in one Master screen and have it sync across the all the documents in a set to eliminate data re-entry and costly human error.",
                    usageCaps: [
                        {
                            plan: PlanKey.FREE,
                            available: true,
                        },
                        {
                            plan: PlanKey.BASIC,
                            available: true,
                        },
                        {
                            plan: PlanKey.PRO,
                            available: true,
                        },
                        {
                            plan: PlanKey.ORG,
                            available: true,
                        },
                    ],
                },
                {
                    name: "Bulk import contacts & products",
                    tooltip: "Import your list of contacts or products from a CSV file so you can get setup in minutes without manually adding information.",
                    usageCaps: [
                        {
                            plan: PlanKey.FREE,
                            available: true,
                        },
                        {
                            plan: PlanKey.BASIC,
                            available: true,
                        },
                        {
                            plan: PlanKey.PRO,
                            available: true,
                        },
                        {
                            plan: PlanKey.ORG,
                            available: true,
                        },
                    ],
                },
                {
                    name: "Record & Track Payments",
                    tooltip: "Record Deposit and Balance amounts on Invoices and Purchase Orders for quick and easy cashflow management.",
                    usageCaps: [
                        {
                            plan: PlanKey.FREE,
                            available: true,
                        },
                        {
                            plan: PlanKey.BASIC,
                            available: true,
                        },
                        {
                            plan: PlanKey.PRO,
                            available: true,
                        },
                        {
                            plan: PlanKey.ORG,
                            available: true,
                        },
                    ],
                },
                {
                    name: "Accept Onine payments",
                    tooltip: "Accept credit card and ACH payments with 'Pay Now' options on your invoices.",
                    usageCaps: [
                        {
                            plan: PlanKey.FREE,
                            available: false,
                        },
                        {
                            plan: PlanKey.BASIC,
                            available: true,
                        },
                        {
                            plan: PlanKey.PRO,
                            available: true,
                        },
                        {
                            plan: PlanKey.ORG,
                            available: true,
                        },
                    ],
                },
                {
                    name: "Remove IncoDocs Watermark",
                    tooltip: "Paid plans will remove the IncoDocs watermark at the bottom left of documents.",
                    usageCaps: [
                        {
                            plan: PlanKey.FREE,
                            available: false,
                        },
                        {
                            plan: PlanKey.BASIC,
                            available: true,
                        },
                        {
                            plan: PlanKey.PRO,
                            available: true,
                        },
                        {
                            plan: PlanKey.ORG,
                            available: true,
                        },
                    ],
                },
                {
                    name: "Download documents as CSV file",
                    tooltip: "Download any document in structured .csv format. Your forwarder will love you.",
                    usageCaps: [
                        {
                            plan: PlanKey.FREE,
                            available: false,
                        },
                        {
                            plan: PlanKey.BASIC,
                            available: false,
                        },
                        {
                            plan: PlanKey.PRO,
                            available: false,
                        },
                        {
                            plan: PlanKey.ORG,
                            available: true,
                        },
                    ],
                },
                {
                    name: "Import CSV data into documents",
                    usageCaps: [
                        {
                            plan: PlanKey.FREE,
                            available: false,
                        },
                        {
                            plan: PlanKey.BASIC,
                            available: false,
                        },
                        {
                            plan: PlanKey.PRO,
                            available: true,
                        },
                        {
                            plan: PlanKey.ORG,
                            available: true,
                        },
                    ],
                },
                {
                    name: "Reporting Features",
                    tooltip: "Click to filter and download reports on sales and shipping information to get instant insight into your business.",
                    comingSoon: true,
                    usageCaps: [
                        {
                            plan: PlanKey.FREE,
                            available: false,
                        },
                        {
                            plan: PlanKey.BASIC,
                            available: false,
                        },
                        {
                            plan: PlanKey.PRO,
                            available: false,
                        },
                        {
                            plan: PlanKey.ORG,
                            available: true,
                        },
                    ],
                },
            ],
        },
        {
            name: "Integrations",
            showPlanTitles: true,
            features: [
                {
                    name: "Accounting System Integrations",
                    tooltip: "Generate export documents from your invoices, quotes & purchase orders in Xero or Quickbooks.",
                    usageCaps: [
                        {
                            plan: PlanKey.FREE,
                            available: true,
                        },
                        {
                            plan: PlanKey.BASIC,
                            available: true,
                        },
                        {
                            plan: PlanKey.PRO,
                            available: true,
                        },
                        {
                            plan: PlanKey.ORG,
                            available: true,
                        },
                    ],
                },
                {
                    name: "API Access",
                    tooltip: "Create custom workflows & integrations with powerful API capabilities.",
                    usageCaps: [
                        {
                            plan: PlanKey.FREE,
                            available: false,
                        },
                        {
                            plan: PlanKey.BASIC,
                            available: false,
                        },
                        {
                            plan: PlanKey.PRO,
                            available: true,
                        },
                        {
                            plan: PlanKey.ORG,
                            available: true,
                        },
                    ],
                },
            ],
        },
        {
            name: "Custom Documents",
            showPlanTitles: true,
            features: [
                {
                    name: "custom document templates",
                    tooltip: "Get document templates modified or new templates added to your workspace to suit your exact company requirements and workflow.",
                    usageCaps: [
                        {
                            plan: PlanKey.FREE,
                            available: false,
                        },
                        {
                            plan: PlanKey.BASIC,
                            available: false,
                        },
                        {
                            plan: PlanKey.PRO,
                            available: true,
                        },
                        {
                            plan: PlanKey.ORG,
                            available: true,
                        },
                    ],
                },
            ],
        },
        {
            name: "Support",
            showPlanTitles: true,
            tooltip: "A comprehensive set of guides to help you and your team make the most of IncoDocs.",
            features: [
                {
                    name: "Self-Service Knowledge Base",
                    usageCaps: [
                        {
                            plan: PlanKey.FREE,
                            available: true,
                        },
                        {
                            plan: PlanKey.BASIC,
                            available: true,
                        },
                        {
                            plan: PlanKey.PRO,
                            available: true,
                        },
                        {
                            plan: PlanKey.ORG,
                            available: true,
                        },
                    ],
                },
                {
                    name: "Priority Support",
                    tooltip: "Get faster responses from our Support team.",
                    usageCaps: [
                        {
                            plan: PlanKey.FREE,
                            available: false,
                        },
                        {
                            plan: PlanKey.BASIC,
                            available: false,
                        },
                        {
                            plan: PlanKey.PRO,
                            available: true,
                        },
                        {
                            plan: PlanKey.ORG,
                            available: true,
                        },
                    ],
                },
                {
                    name: "Team Video Setup Call",
                    usageCaps: [
                        {
                            plan: PlanKey.FREE,
                            available: false,
                        },
                        {
                            plan: PlanKey.BASIC,
                            available: false,
                        },
                        {
                            plan: PlanKey.PRO,
                            available: false,
                        },
                        {
                            plan: PlanKey.ORG,
                            available: true,
                        },
                    ],
                },
                {
                    name: "Dedicated Account Manager",
                    tooltip: "You will get assigned a dedicated account manager with direct contact phone number and contact details to answer your questions.",
                    usageCaps: [
                        {
                            plan: PlanKey.FREE,
                            available: false,
                        },
                        {
                            plan: PlanKey.BASIC,
                            available: false,
                        },
                        {
                            plan: PlanKey.PRO,
                            available: false,
                        },
                        {
                            plan: PlanKey.ORG,
                            available: true,
                        },
                    ],
                },
                {
                    name: "1-on-1 Team Training & Support",
                    tooltip: "Get a personal video setup call with our onboarding team to give your team a detailed demo and answer any questions.",
                    usageCaps: [
                        {
                            plan: PlanKey.FREE,
                            available: false,
                        },
                        {
                            plan: PlanKey.BASIC,
                            available: false,
                        },
                        {
                            plan: PlanKey.PRO,
                            available: false,
                        },
                        {
                            plan: PlanKey.ORG,
                            available: true,
                        },
                    ],
                },
            ],
        },
    ],
};
//# sourceMappingURL=CurrentPriceComparisonProps.js.map